module.exports = __webpack_public_path__ + "static/media/9.91113e89.JPG";